import React from "react";

const NoData = (props) => {
  return (
    <div
      className="mt-5"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <p>{props.text}</p>
    </div>
  );
};

export default NoData;
